import React from "react";
import { connect } from "react-redux";
import { Route, Redirect } from "react-router-dom";
import { authExist, forceResetPass } from "common/helper/utilities";

const PrivateRoute = ({ component: Component, ...rest }) => {
    const userProfileExist = rest.userProfile.auth;
    const token = userProfileExist ? rest.userProfile.auth.token : null;
    return <Route {...rest} render={(props) => (authExist(token) && !forceResetPass(token) ? <Component {...props} /> : <Redirect to="/admin" />)} />;
};

const mapStateToProps = (state) => {
    return {
        userProfile: state.userProfile,
    };
};

export default connect(mapStateToProps, null)(PrivateRoute);
